import { Observable } from 'rxjs';

import {
	AddDevicesToGatewayResult,
	CloudGatewayDiscoveredDevice,
	CloudGatewayDiscoveryStatus,
	RemoveDevicesFromGatewayResult
} from '@shure/cloud/shared/models/devices';

export interface DiscoveryResult {
	status: CloudGatewayDiscoveryStatus;
	discoveredDevices: CloudGatewayDiscoveredDevice[];
}

export abstract class CloudGatewayApiService {
	public abstract scanDiscoveredDevicesForGateway$(gatewayId: string): Observable<DiscoveryResult>;
	public abstract addDevices$(gatewayId: string, deviceIds: string[]): Observable<AddDevicesToGatewayResult>;
	public abstract removeDevices$(gatewayId: string, deviceIds: string[]): Observable<RemoveDevicesFromGatewayResult>;
	public abstract cleanupSubscriptions(): void;
}
